/**
 * @file annotationViewCreate.saga.js
 * @description requests view data for a single annotation
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Dec 01, 2022 17:09
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import {
    annotationViewOpenDialogSet,
} from 'src/store/actions/annotationView.actions';

import {
    ANNOTATION_VIEW_CREATE_REQUEST,
    annotationViewCreateSuccess,
    annotationViewCreateFailure,
} from 'src/store/actions/annotationView.actions';

// note: dataLoadingSet causes pages to refresh!
// import { dataLoadingSet } from 'src/store/actions/global.actions';
import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi(payload) {
    const url = '/annotationView/annotationViewCreate';

    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
            annotationId: payload,
        },
    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* requestSaga(action) {

    try {
        // yield put(dataLoadingSet(true));

        const resp = yield call(callApi, action.payload);

        yield put(annotationViewCreateSuccess(resp.payload));

        yield put(annotationViewOpenDialogSet(true));

    } catch (error) {
        yield put(annotationViewCreateFailure(error));
        handleSagaErrors(error);

    } finally {
        // yield put(dataLoadingSet(false));
    }
}

export default function* requestMonitor() {
    yield takeLatest(ANNOTATION_VIEW_CREATE_REQUEST, requestSaga);
}
